import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;
const crmPath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;
const webPath = `/web/${process.env.VUE_APP_COMPANY_KEY}`;
const apiPath = '/api';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

export const checkBinding = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-binding`
  });

export const sendSmsValidate = (mobile_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/send-sms-validate`,
    body: mobile_info
  });

export const validateSmsAndBinding = (validate_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/validate-sms-and-binding`,
    body: validate_info
  });

export const checkSMS = (info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-sms`,
    body: info
  });

export const checkIsMember = (validate_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-member-bind`,
    body: validate_info
  });

export const getMemberCrmInfo = (mobile) => callApi({
    method: 'GET',
    endpoint: `${apiPath}/search/member?mobile=${mobile}`
  });

export const sendBinding = (info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/validate-sms-and-binding`,
    body: info
  });

export const checkMemberBind = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check-member-bind`,
  body: info
});

// 獨立註冊頁用的簡訊api
export const sendSmsValidateIndependant = (mobile_info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/send-sms-independent`,
  body: mobile_info
});
// 獨立註冊頁綁定用api
export const sendBindingIndependant = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/independent`,
  body: info
});
// 獨立註冊頁綁定用api
export const getRecommendStores = (info) => callApi({
  method: 'GET',
  endpoint: `${crmPath}/pos/recommend-stores?${buildQueryUrlFromObject(info)}`,
});

// 取得縣市地區下拉
export const getCityDropdown = (info) => callApi({
  method: 'GET',
  endpoint: `${apiPath}/city-zip`,
});

// 綁定禮貼標
export const postBindingGiftUserTag = (info) => callApi({
  method: 'POST',
  endpoint: `${crmPath}/binding-gift/user-tag`,
  body: info
});

export const getBindingGiftCheck = (info) => callApi({
  method: 'GET',
  endpoint: `${crmPath}/binding-gift/check?${buildQueryUrlFromObject(info)}`,
});
